import { Dropdown } from 'primereact/dropdown';
import { Button } from 'primereact/button';
import { Checkbox } from 'primereact/checkbox';
import { jsPDF } from 'jspdf';
import React, { useState, useEffect, useRef } from 'react';
import Loader from "../../Shared/Loader/Loader";
import APIConstant from "../../../utils/pathConstants";
import api from "../../../utils/apiClient";
import CommonConfig from '../../../utils/constant';
import Toast from '../../Shared/Toast/Toast';
import HallTicketExportPDF from '../../Export/HallTicketExportPDF';
import downloadjs from 'downloadjs';
import html2canvas from 'html2canvas';
import { useReactToPrint } from "react-to-print";
import JSZip from 'jszip';
import { useCatchResponse } from '../../../utils/useCatchResponse';

const HallTicketCard = (props) => {
    const { catchResponse } = useCatchResponse();
    const [templateList, setTemplateList] = useState([]);
    const [templateId, setTemplateId] = useState('');
    const [templateErr, setTemplateErr] = useState(false);
    const [meta, setMeta] = useState({});
    const [sendNotify, setSendNotify] = useState(false);
    const elementRef = useRef(null);

    const printFn = useReactToPrint({ contentRef: elementRef, documentTitle: "HallTicket" });

    useEffect(() => {
        const loginData = CommonConfig.loginData();
        GetTemplateList(loginData?._id);
    }, []);

    const GetTemplateList = async (userId) => {
        try {
            const res = await api.post(APIConstant.path.GetHallTicketTemplateListByClassId, { ClassId: props?.classDetailId, FinancialYearId: props?.financialYearId, UserId: userId });
            const list = (res?.success ? res.data : []).map(x => ({ ...x, label: x?.TemplateName, value: x?._id }));
            setTemplateList(list);
            const firstId = list.length ? list[0].value : '';
            setTemplateId(firstId);
            GetMeta(firstId);
        } catch (err) { catchResponse(err); }
    };

    const GetMeta = async (tId) => {
        try {
            Loader.show();
            const res = await api.post(APIConstant.path.GetHallTicketMeta, { ExamScheduleId: props?.examScheduleId, TemplateId: tId, FinancialYearId: props?.financialYearId });
            if (res?.success) setMeta(res.data);
            else Toast.error({ message: res?.message });
            Loader.hide();
        } catch (err) { Loader.hide(); catchResponse(err); }
    };

    const saveBlocks = async () => {
        try {
            const loginData = CommonConfig.loginData();
            const Allotments = (props?.studentsData || []).map(s => ({ StudentId: s?.id, AdmissionId: s?.AdmissionId || '', Block: s?.Block || '' }));
            await api.post(APIConstant.path.SaveHallTicketBlocks, {
                ExamScheduleId: props?.examScheduleId,
                FinancialYearId: props?.financialYearId,
                ClassDetailId: props?.classDetailId,
                CreatedBy: loginData?._id,
                Allotments,
            });
        } catch (err) { catchResponse(err); }
    };

    const validate = () => {
        if (CommonConfig.isEmpty(templateId)) { setTemplateErr(true); return false; }
        setTemplateErr(false);
        return true;
    };

    const generatePDF = async () => {
        if (!validate()) return;
        await saveBlocks();
        try { printFn(); } catch (error) { Loader.hide(); }
        if (sendNotify) await sendHallTicketNotifications();
    };

    const sendHallTicketNotifications = async () => {
        try {
            const container = document.getElementById('pdf-hallticket-content');
            if (!container) return;
            const cards = container.querySelectorAll('[id^="hallticket-"]');
            const students = props?.studentsData || [];
            if (!cards.length) return;
            Loader.show();
            const formData = new FormData();
            const recipients = [];
            for (let i = 0; i < cards.length; i++) {
                const stu = students[i];
                if (!stu) continue;
                const cardClone = cards[i].cloneNode(true);
                cardClone.style.width = '1000px';
                document.body.appendChild(cardClone);
                const canvas = await html2canvas(cardClone, { scale: 2, useCORS: true, allowTaint: true });
                cardClone.remove();
                const imgData = canvas.toDataURL('image/jpeg', 0.9);
                const pdf = new jsPDF('p', 'pt', 'a4');
                const pageWidth = pdf.internal.pageSize.getWidth();
                const imgWidth = pageWidth - 40;
                const imgHeight = (canvas.height * imgWidth) / canvas.width;
                pdf.addImage(imgData, 'JPEG', 20, 20, imgWidth, imgHeight);
                const blob = pdf.output('blob');
                const safeName = (stu?.Name || 'student').replace(/[^a-zA-Z0-9-_]/g, '_').slice(0, 40);
                formData.append('HallTickets', blob, `HallTicket_${safeName}.pdf`);
                recipients.push(stu?.id);
            }
            if (!recipients.length) { Loader.hide(); return; }
            const loginData = CommonConfig.loginData();
            formData.append('Recipients', JSON.stringify(recipients));
            formData.append('ExamScheduleId', props?.examScheduleId || '');
            formData.append('FinancialYearId', props?.financialYearId || '');
            formData.append('ClassDetailId', props?.classDetailId || '');
            formData.append('ExamTitle', meta?.ExamTitle || '');
            formData.append('SchoolId', CommonConfig.isOrgOwner(loginData?.UserRole) ? loginData?._id : loginData?.CreatedBy);
            formData.append('CreatedBy', loginData?._id);
            const res = await api.post(APIConstant.path.SendHallTicketNotification, formData, { headers: { 'Content-Type': 'multipart/form-data' } });
            Loader.hide();
            if (res?.success) Toast.success({ message: res?.message || 'Hall ticket notifications sent' });
            else Toast.error({ message: res?.message || 'Failed to send notifications' });
        } catch (err) { Loader.hide(); catchResponse(err); }
    };

    const generateJPGs = async () => {
        if (!validate()) return;
        await saveBlocks();
        const container = document.getElementById('pdf-hallticket-content');
        if (!container) return;
        const cards = container.querySelectorAll('[id^="hallticket-"]');
        if (!cards.length) return;
        const zip = new JSZip();
        const imgFolder = zip.folder("HallTickets");
        for (let i = 0; i < cards.length; i++) {
            const card = cards[i];
            try {
                Loader.show();
                const cardClone = card.cloneNode(true);
                cardClone.style.width = '1000px';
                document.body.appendChild(cardClone);
                const canvas = await html2canvas(cardClone, { scale: 2, useCORS: true, allowTaint: true });
                cardClone.remove();
                const dataURL = canvas.toDataURL('image/jpeg', 0.9);
                imgFolder.file(`HallTicket-${i + 1}.jpg`, dataURL.split(',')[1], { base64: true });
                Loader.hide();
            } catch (error) { Loader.hide(); }
        }
        zip.generateAsync({ type: "blob" }).then((content) => {
            downloadjs(content, "HallTickets.zip", "application/zip");
        }).catch(() => Loader.hide());
        if (sendNotify) await sendHallTicketNotifications();
    };

    return (
        <div>
            <div className='p-grid'>
                <div className="p-col-12 p-md-12 p-pt-2">
                    <label htmlFor="hallTicketTemplate" className="mr-2">Hall Ticket Template</label>
                    <div className="custom-inputs">
                        <Dropdown className='p-mt-1 p-w-100' id="hallTicketTemplate" value={templateId} options={templateList} onChange={(e) => { setTemplateId(e.value); GetMeta(e.value); }} placeholder="Select Hall Ticket Template" filter showClear />
                    </div>
                    <span className="p-error block" style={{ color: 'red' }}>{templateErr ? 'Hall Ticket Template is required' : null}</span>
                </div>
                <div className="p-col-12 p-md-12 p-pt-2">
                    <div className="p-d-flex p-ai-center">
                        <Checkbox inputId="sendNotify" checked={sendNotify} onChange={(e) => setSendNotify(e.checked)} />
                        <label htmlFor="sendNotify" className="p-ml-2">Send notification to students with hall ticket</label>
                    </div>
                    {sendNotify && (
                        <small style={{ color: '#64748b', display: 'block', marginTop: 4, marginLeft: 26 }}>
                            <i className="pi pi-info-circle" style={{ fontSize: 11, marginRight: 4 }} />
                            Already shared? Fix the details and generate again — re-sending replaces the previously shared hall ticket for these students.
                        </small>
                    )}
                </div>
            </div>
            <div className="dialog-footer p-d-flex p-ai-center p-jc-between p-px-5">
                <div className='p-d-flex p-ai-center'>
                    <Button icon="pi pi-file-pdf" rounded className="e-border-btn p-m-0" tooltip={"Generate PDF"} tooltipOptions={{ position: 'top' }} onClick={generatePDF}></Button>
                    <Button icon="pi pi-images" rounded className="e-h-btn p-my-0 p-ml-2" tooltip={"Generate JPG"} tooltipOptions={{ position: 'top' }} onClick={generateJPGs}></Button>
                </div>
                <div className='p-d-flex p-ai-center p-jc-end'>
                    <Button className='btn-text-action-secondary' onClick={() => props?.onCancel()}> Cancel </Button>
                </div>
            </div>
            <div className='p-d-none'>
                <HallTicketExportPDF ref={elementRef} meta={meta} pdfData={props?.studentsData || []} />
            </div>
        </div>
    );
};

export default HallTicketCard;
